import { createReducer, on } from '@ngrx/store'
import {
  login,
  loginFailure,
  loginSuccess,
  logout,
  restoreSession,
} from './authentication.actions'
import type { EmployeeBasicInfoDto, AuthResultDto, MenuDto } from './auth.model'

export interface AuthenticationState {
  isLoggedIn: boolean
  employee: EmployeeBasicInfoDto | null
  authResult: AuthResultDto | null
  menus: MenuDto[]
  error: string | null
}

const initialState: AuthenticationState = {
  isLoggedIn: false,
  employee: null,
  authResult: null,
  menus: [],
  error: null,
}

export const authenticationReducer = createReducer(
  initialState,
  on(login, (state) => ({ ...state, error: null })),
  on(loginSuccess, (state, { employee, authResult, menus }) => ({
    ...state,
    isLoggedIn: true,
    employee,
    authResult,
    menus,
    error: null,
  })),
  on(loginFailure, (state, { error }) => ({ ...state, error })),

  on(restoreSession, (state, { employee, authResult, menus }) => ({
    ...state,
    isLoggedIn: true,
    employee,
    authResult,
    menus,
  })),

  on(logout, (state) => ({
    ...state,
    isLoggedIn: false,
    employee: null,
    authResult: null,
    menus: [],
  }))
)
